/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Result_LabelInputs */

const en_diff_result_label = /** @type {(inputs: Diff_Result_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differences`)
};

const ko_diff_result_label = /** @type {(inputs: Diff_Result_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차이점`)
};

const ja_diff_result_label = /** @type {(inputs: Diff_Result_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差分`)
};

/**
* | output |
* | --- |
* | "Differences" |
*
* @param {Diff_Result_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_result_label = /** @type {((inputs?: Diff_Result_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Result_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_result_label(inputs)
	if (locale === "ko") return ko_diff_result_label(inputs)
	return ja_diff_result_label(inputs)
});